import { observer } from "mobx-react";
import { FieldAlias, FieldTypeId } from "../../../lib/enums";
import { MeasurementSaveRequest } from "../../../models/Measurements";
import { CustomForm } from "../../customform/CustomForm";
import CustomDatePicker from "../../customform/fields/DateTime/CustomDatePicker";
import CustomTextInput from "../../customform/fields/Text/CustomTextInput";
import FormRow from "../../customform/layout/FormRow";
import { useStoreContext } from "../../..";
import React from "react";
import { GenericDataFormSchema } from "../../customform/types";

const MyNotesForm = observer(
  ({
    selectedDay,
    onDeSelect,
  }: {
    selectedDay: any | undefined;
    onDeSelect: () => void;
  }) => {
    const myNoteFieldAliases = [
      FieldAlias.D_PERDIAGNOS,
      FieldAlias.D_PERDRUGS,
      FieldAlias.D_PERCOMMENTS,
    ];

    const { measurementStore } = useStoreContext();

    const saveNotes = async (data: any) => {
      if (!data) {
        return;
      }
      const saveRequests: MeasurementSaveRequest[] = [];
      myNoteFieldAliases.forEach((alias) => {
        const value = data[alias];
        if (value) {
          saveRequests.push({
            date: data.date,
            fieldAlias: alias,
            value: value,
          });
        }
      });
      saveRequests.forEach(async (request) => {
        await measurementStore.saveMeasurement(
          request as MeasurementSaveRequest
        );
      });
      await measurementStore.getSymptoms();
    };

    return (
      <CustomForm
        zodDataSchema={GenericDataFormSchema}
        currentData={selectedDay as any}
        hideDeleteAndEditButtons
        hideReadOnlyChip
        hideSaveButton
        onSave={saveNotes}
        onDeSelect={onDeSelect}
      >
        <FormRow gapAfter>
          <CustomDatePicker
            required
            alias="date"
            header="Datum"
            fieldId={0}
            typeId={FieldTypeId.DATE}
            nonForm
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomTextInput
            alias={FieldAlias.D_PERDIAGNOS}
            header="Diagnos"
            multiline
            fieldId={0}
            typeId={FieldTypeId.MULTILINE_TEXT}
            nonForm
            width={12}
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomTextInput
            alias={FieldAlias.D_PERDRUGS}
            header="Läkemedel"
            multiline
            fieldId={0}
            typeId={FieldTypeId.MULTILINE_TEXT}
            nonForm
            width={12}
          />
        </FormRow>
        <FormRow gapAfter>
          <CustomTextInput
            alias={FieldAlias.D_PERCOMMENTS}
            header="Kommentar"
            multiline
            fieldId={0}
            typeId={FieldTypeId.MULTILINE_TEXT}
            nonForm
            width={12}
          />
        </FormRow>
      </CustomForm>
    );
  }
);

export default MyNotesForm;
